import {combineReducers} from "redux";
import {appReducer} from "./appReducer";

export const mainReducer = combineReducers({
    app: appReducer,
})